import { httpRequest } from "../../http";
import {LoginInfoSerializer} from "../../../models/serializers/loginInfoSerializer.ts";

export class CommandLogin {

    getUrl() {
        return '';
    }

    async run(userName: string, password: string) {
        const params = {
            "username": userName,
            "password": password
        };

        try {
           const response = await httpRequest<any>(`${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/login/`, {
                method: "POST",
                body: params,
                auth: false
            });

            return this.deserialize(response);

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: Record<string,any>) {

        const serializer = new LoginInfoSerializer();
        const loggedInUser = serializer.deserialize(data);

        return loggedInUser;

    }

}

